(function () {
    var $body = $('body');

    var refine = {
        $target: null,
        $targets: $('.refineSearch'),
        $showController: $('.quick-search__ctrl__refine'),
        $hideController: $('.quick-search__ctrl__refine--hide'),
        $elements: $('.refineSearch__row'),
        ctrls: document.querySelectorAll('.search__result .advanced-search__ctrl'),
        $wrapper: null,
        isMobile: false,
        vPort: 'screen-sm', // default responsive break point
        escape: 27,

        init: function () {
            refine.control();
            if ($('.quick-search').length) {
                refine.on.hide();
            }
        },
        control: function () {
            refine.on.viewPortListener();
            refine.click.toggleSearchBlock();

            $body.on('click', '.refineSearch__ctrl__remove', function (e) {
                e.preventDefault();
                const $this = $(this);
                refine.$target = $this.closest('.refineSearch');
                refine.$wrapper = refine.$target.find('.refineSearch__texts');
                refine.on.remove($this);
            });

            $body.on('click', '.refineSearch__ctrl__add', function (e) {
                e.preventDefault();
                const $this = $(this);
                refine.$target = $this.closest('.refineSearch');
                refine.$wrapper = refine.$target.find('.refineSearch__texts');
                refine.on.clone($this);
            });

            $body.on('click', '.quick-search__ctrl__refine', function (e) {
                e.preventDefault();
                if (refine.$targets.length) {
                    refine.on.show();
                }
            });

            $body.on('click', '.quick-search__ctrl__refine--hide', function (e) {
                e.preventDefault();
                refine.on.hide();
            });

            $body.on('click', function (e) {
                if (
                    !refine.$targets.is(e.target) && // if the target of the click isn't the container...
                    refine.$targets.has(e.target).length === 0 && // ... nor a descendant of the container
                    !refine.$showController.is(e.target) && // if the target of the click isn't the controller...
                    refine.$showController.has(e.target).length === 0 && // ... nor a descendant of the controller
                    !$(e.target).closest('.jcf-select-drop').length &&
                    !refine.$targets.closest('.search-result__refine-search').length &&
                    !$(e.target).closest('.refineSearch__ctrl__remove').length
                ) {
                    refine.on.hide();
                }
            });

            $(document).on('keydown', function (e) {
                if ((e.keyCode || e.which) === refine.escape) {
                    refine.on.hide();
                }
            });
        },
        click: {
            toggleSearchBlock: function () {
                const tabs = document.querySelectorAll('.search-result__meta .advancedSearch__tabs');
                refine.ctrls.forEach(ctrl => {
                    ctrl.addEventListener('click', function (e) {
                        e.preventDefault();
                        if (!refine.isMobile) {
                            ctrl.classList.toggle('js--open');
                            ctrl.setAttribute(
                                'aria-expanded',
                                ctrl.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'
                            );
                            tabs.forEach(tab => {
                                tab.classList.toggle('advancedSearch__tabs--hidden');
                            });
                        }
                    });
                });
            },
        },
        on: {
            clone: function ($this) {
                window.jcf.destroyAll();
                $this
                    .closest('.refineSearch__row')
                    .clone(true, true)
                    .find('input')
                    .attr('name', 'text' + ($('.refineSearch__row').length + 1).toString())
                    .val('')
                    .end()
                    .appendTo(refine.$wrapper);
                $this.addClass('hidden');
                $this.siblings('.refineSearch__ctrl__remove').removeClass('hidden');
                $('.jcf').each(function () {
                    jcf.replace($(this)); /*eslint-disable-line*/
                });
            },
            remove: function ($this) {
                $this.closest('.refineSearch__row').remove();
            },
            show: function () {
                refine.$showController.addClass('hidden');
                refine.$hideController.removeClass('hidden');
                refine.$targets.addClass('js--open');
                refine.$targets.show();
            },
            hide: function () {
                refine.$targets.each(function () {
                    if ($body.attr('data-active') === 'refine') {
                        $body.removeAttr('data-active');
                    }
                    refine.$hideController.addClass('hidden');
                    refine.$showController.removeClass('hidden');
                    refine.$targets.removeClass('js--open');
                    refine.$targets.hide();
                });
            },
            viewPortListener: function () {
                $(document).on(refine.vPort + '-on', function () {
                    // Waiting for custom event that will be triggered by controller.js to activate responsive effects
                    refine.isMobile = true;
                    refine.on.setPopupAttr(true);
                });

                $(document).on(refine.vPort + '-off', function () {
                    // Waiting for custom event that will be triggered by controller.js to deactivate responsive effects
                    refine.isMobile = false;
                    refine.on.setPopupAttr(false);
                });
            },
            setPopupAttr: function (isTrue = false) {
                refine.ctrls.forEach(ctrl => {
                    ctrl.setAttribute('aria-haspopup', isTrue ? 'menu' : 'false');
                });
            },
        },
    };

    UX.refine = refine; // add to global namespace
})();
